export const middleware = () => (next) => (action) => next(action);
